import LegendIcon from "./LegendIcon";
export default LegendIcon;
